import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useAccountStore } from '../../components/Stores/accountStore';
import { useExposureStore } from '../../components/Stores/exposureDataStore';
import { useMaterialsStore } from '../../components/Stores/MaterialsStore';
import { useCardBar } from '../../components/FormulaCardBar/useCardBar';
import { LoadingLogoComponent } from '../Quotes/LoadingLogoComponent';
import { OpportunitySummaryDashboard } from './components/SummaryDashboard/SummaryDashboard';
import { TransactionTable } from './components/TransactionTable/TransactionTable';
import { getUpdatedTransactionOpportunity } from './opportunityDashboardUtils';
import { transactionOpportunitiesMock } from './opportunityTransactionsMock';
import { useTransaction } from '../../hooks/useTransactionByAccount';

export const OpportunityDashboard = () => {
  const { materialsMap } = useMaterialsStore();
  const { account } = useAccountStore();

  useCardBar({});

  const { formulasToAccount } = account;
  const { currentSelectedFormulaId, netExposure, setCurrentSelectedFormulaId } = useExposureStore();
  const { data: transactionsFetchedData } = useTransaction();
  const [transactionDataSet, setTransactionDataSet] = useState(transactionOpportunitiesMock);
  const [filteredTransactions, setFilteredTransactions] = useState(
    getUpdatedTransactionOpportunity(transactionDataSet, currentSelectedFormulaId, materialsMap),
  );

  useEffect(() => {
    transactionsFetchedData && transactionsFetchedData.length && setTransactionDataSet(transactionsFetchedData);
  }, [transactionsFetchedData]);

  useEffect(() => {
    setFilteredTransactions(
      getUpdatedTransactionOpportunity(transactionDataSet, currentSelectedFormulaId, materialsMap),
    );
  }, [currentSelectedFormulaId, materialsMap, transactionDataSet]);

  useEffect(() => {
    const ShowToast = () =>
      !filteredTransactions.length && showToast('No Transactions available for this material', '1');

    ShowToast();
  }, [filteredTransactions]);

  return (
    <>
      {account && materialsMap ? (
        <div className="flex flex-1 flex-col h-full gap-6 pb-4 pe-2 overflow-hidden">
          <div className="flex shadow-custom max-h-[15rem] overflow-hidden ">
            <OpportunitySummaryDashboard data={filteredTransactions} />
          </div>
          <div className="flex flex-1 overflow-auto shadow-custom">
            <TransactionTable data={filteredTransactions} />
          </div>
        </div>
      ) : (
        <LoadingLogoComponent />
      )}
    </>
  );
};

const showToast = (message: string, toastId: string) => {
  if (!toast.isActive(toastId)) {
    toast.info(message, {
      toastId,
    });
  }
};
